import React, { useEffect } from "react";

const Slider = (props: { value: number }) => {
  const { value } = props;

  const [min, setMin] = React.useState(value);
  const [max, setMax] = React.useState(value);

  useEffect(() => {
    setMin(Math.min(props.value, min));
    setMax(Math.max(props.value, max));
  }, [props.value]);

  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      <div>
        <small>{min.toFixed(1)}</small>
      </div>
      <div
        style={{
          background: "white",
          borderRadius: "4px",
          height: "16px",
          overflow: "hidden",
          position: "relative",
          flex: 1,
          margin: "0px 4px",
        }}
      >
        <div
          style={{
            backgroundColor: "hsl(from var(--primary) h s 15 / 100%)",
            position: "relative",
            left: 0,
            top: 0,
            height: "100%",
            width: `${((value - min) / (max - min || 0.1)) * 100}%`,
          }}
        ></div>
      </div>
      <div>
        <small>{max.toFixed(1)}</small>
      </div>
    </div>
  );
};

export default Slider;
